import { createAuthClient } from 'better-auth/react';

// Use a relative URL so requests go through the Vite dev proxy and
// cookies stay scoped to the web origin (http://localhost:5173 in dev,
// the same origin in production). Calling the API on a different port
// would scope cookies to that port and break the session.
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL ?? '',
});

/** Sign out, always sync client state, and always redirect. */
export const signOutAndRedirect = async (
  redirect: () => void,
  onSettled?: (success: boolean) => Promise<void>,
) => {
  let success = false;
  try {
    await authClient.signOut();
    success = true;
  } catch (e) {
    console.error('Sign out failed', e);
  }
  // Always sync client state and show feedback, even if server call failed.
  await onSettled?.(success);
  redirect();
};
